import { withMotionMax } from '@hoc/withMotionMax';
import { useInView } from '@hooks/useInView';
import Controls from '@stories/Components/Global/Carousels/Carousel/Controls/Controls';
import DotPagination from '@stories/Components/Global/DotPagination/DotPagination';
import * as React from 'react';
import BannerItem from './BannerItem/BannerItem';
import S from './HeroBannerCarousel.styles';
const HeroBannerCarousel = (props) => {
    const [activeIndex, setActiveIndex] = React.useState(0);
    const [refContainer, inView] = useInView({}, true);
    if (!props.items || props.items.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, { ref: refContainer, site: props.site, spacing: 'none', layout: 'fullWidth' },
        props.items.map((item, index) => (React.createElement(BannerItem, { key: item.id, ...item, active: index === activeIndex ? 'active' : index > activeIndex ? 'after' : 'before', index: index, shouldPlay: inView, site: props.site }))),
        React.createElement(S.Inner, null, props.items.length > 1 && (React.createElement(S.PaginationWrapper, null,
            React.createElement(DotPagination, { ariaLabel: 'Home banner carousel controls', count: props.items.length, value: activeIndex, onChange: (index) => setActiveIndex(index), site: props.site }),
            React.createElement(Controls, { onClickPrev: () => setActiveIndex(Math.max(activeIndex - 1, 0)), onClickNext: () => setActiveIndex(Math.min(activeIndex + 1, props.items.length - 1)), activeIndex: activeIndex, maxIndex: props.items.length - 1 }))))));
};
export default withMotionMax(HeroBannerCarousel);
